<template>
    <div>
        <div class="d-flex align-items-center mb-3">
            <div>
                <h1 class="page-header mb-0"><i class="fa-solid fa-list-check"></i> Rendszerüzenetek</h1>
            </div>
            <div class="ms-auto">
                <new-message mode="new" :users="users" @refresh="refresh"></new-message>
            </div>
        </div>
        <panel title="Rendszerüzenetek">
            <Loading title="Feladatok betöltése" v-if="!messages"></Loading>
            <NoRecords v-else-if="messages.length == 0" main_icon="fa fa-list-check" value="false"
                title="Nincsenek rendszerüzenetek" subtitle="hozzon létre újat"></NoRecords>
            <div v-else>
                <vue-good-table :columns="columns" :rows="messages" :fixed-header="true"
                            max-height="600px" :search-options="{ enabled: false, placeholder: 'Keresés...' }"
                            :pagination-options="{
                                enabled: true,
                                position: 'bottom',
                                firstLabel: 'Első Lap',
                                lastLabel: 'Utolsó Lap',
                                nextLabel: 'következő',
                                prevLabel: 'előző',
                                rowsPerPageLabel: 'Sor oldalanként',
                                perPage: -1,
                                ofLabel: '/',
                                allLabel: 'Összes',
                                infoFn: (params) => `első sorszám: ${params.firstRecordOnPage}`,
                            }" :row-style-class="rowStyleClassFn">
                            <template slot="table-row" slot-scope="props">
                                <span v-if="props.column.field == 'actions'">
                                    <new-message mode="edit" :message="props.row" :users="users" @refresh="refresh"></new-message>
                                    <button @click="deleteSystemMessage(props.row.id)" class="btn btn-sm btn-danger mx-1" title="törlés">
                                        <i class="fa fa-trash"></i>
                                    </button>
                                </span>
                                <span v-if="props.column.field == 'users'">
                                    <span v-for="user in props.row.users" :key="user.id">
                                        {{ user.name }} ({{ user.pivot.read_at ? user.pivot.read_at : 'nem olvasta még' }}) <br>
                                    </span>
                                </span>
                                <span v-else>
                                    {{ props.formattedRow[props.column.field] }}
                                </span>
                            </template>
                        </vue-good-table>
            </div>
            
        </panel>
        
    </div>
    
</template>


<script>
import Loading from '../../components/Loading';
import NoRecords from '../../components/NoRecords';
import User from '../../apis/User';
import SystemMessage from '../../apis/SystemMessage';
import NewMessage from './partials/NewMessage.vue'
export default {
    components: {
        Loading, NoRecords, NewMessage
    },
    data() {
        return {
            messages:false,
            users:false,
            errors: [],
            columns: [
                {
                    label: '',
                    field: 'actions',
                },
                {
                    label: 'Prioritás',
                    field: 'priority_label'
                },
                {
                    label: 'Létrehozta',
                    field: 'created_by_name'
                },
                {
                    label: 'Üzenet',
                    field: 'message',
                    formatFn: (value) => {
                        return value.length > 50 ? value.substring(0, 50) + '...' : value;
                    }
                },
                {
                    label: 'Láthatóság kezdete',
                    field: 'visible_from'
                },
                {
                    label: 'Láthatóság vége',
                    field: 'visible_to'
                },
                {
                    label: 'Felhasználók',
                    field: 'users'
                },
                
            ]
        }
    },
    created() {
        SystemMessage.index().then(response => {
            this.messages = response.data;
        });   
        
        User.index().then(response => {
            this.users = response.data;
        });

    },
    computed: {        
    },
    methods: {
        refresh() {
            SystemMessage.index().then(response => {
                this.messages = response.data;
            });
        },
        rowStyleClassFn(row) {
            if (row.priority == '1') {
                return 'bg-opacity-25 bg-success';
            } else if (row.priority == '2') {
                return 'bg-opacity-25 bg-warning';
            } else if (row.priority == '3') {
                return 'bg-opacity-25 bg-danger';
            }
        },
        deleteSystemMessage(id) {
            if (confirm('Biztosan törölni szeretné?')) {
                SystemMessage.delete(id).then(() => {
                    this.refresh();
                });
            }
        },
        closeModal(){
            this.$bvModal.hide('readingConfirmations')
        },
    }
}
</script>